import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinranjangaonmidc() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Ranjangaon MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Ranjangaon MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Corporate Cab Services in Ranjangaon MIDC, tailored for manufacturing plants, industrial units, warehouses, and corporate offices operating in this major industrial corridor. Our fleet of well-maintained sedans, SUVs, and staff-transport vehicles ensures smooth, punctual, and safe commuting for employees, supervisors, executives, and visiting clients. With trained chauffeurs, GPS-enabled vehicles, and flexible rental options, we deliver efficient shift-based transportation and dedicated corporate mobility solutions. Whether your company needs daily pick-and-drop, management travel, client transfers, or long-term corporate cab services, Pune Corporate Cars India Private Limited guarantees dependable, high-quality, and hassle-free transportation for Ranjangaon MIDC.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Ranjangaon Employee Shuttle",
    "description": "Ranjangaon Employee Shuttle offers reliable and efficient group transportation for employees working in Ranjangaon MIDC. With AC minibuses, vans, and tempo travellers, this service supports multi-shift operations and fixed-route shuttles. Trained drivers, punctual schedules, and safe travel ensure smooth daily commuting for large teams across industrial zones."
  },
  {
    "name": "Industrial Cab Ranjangaon",
    "description": "Industrial Cab Ranjangaon is designed for factory workers, supervisors, and office staff working inside Ranjangaon MIDC. The service includes AC/non-AC cabs, verified drivers, and flexible pickup points to match industrial timings. Industrial Cab Ranjangaon ensures safe, punctual, and dependable travel for all employee levels."
  },
  {
    "name": "Company Staff Transport Ranjangaon",
    "description": "Company Staff Transport Ranjangaon provides structured transportation solutions for companies requiring daily employee pick-up and drop. Ideal for factories, warehouses, and industrial units, the service includes well-maintained vehicles, GPS tracking, and professional drivers. Company Staff Transport Ranjangaon ensures smooth and consistent staff mobility."
  },
  {
    "name": "Employee Pickup Drop Ranjangaon",
    "description": "Employee Pickup Drop Ranjangaon ensures timely and safe daily commute for workers and corporate staff. This service supports night shifts, early-morning operations, and multi-route pickups. With trained drivers and optimized routing, Employee Pickup Drop Ranjangaon offers a reliable and comfortable travel experience."
  },
  {
    "name": "Business Cab Service Ranjangaon",
    "description": "Business Cab Service Ranjangaon provides executive travel solutions for managers, visitors, and corporate teams. With clean AC sedans, SUVs, and chauffeur-driven cars, it supports plant visits, business meetings, and intercity corporate travel. Business Cab Service Ranjangaon ensures professionalism, comfort, and punctuality."
  },
  {
    "name": "Factory Transport Ranjangaon",
    "description": "Factory Transport Ranjangaon offers large-capacity shuttles and vans for transporting factory workers across MIDC and nearby towns. The service ensures timely shift changes, safe travel, and cost-effective workforce movement. Factory Transport Ranjangaon is ideal for industries with high employee volumes."
  },
  {
    "name": "Best Corporate Cabs Ranjangaon",
    "description": "Best Corporate Cabs Ranjangaon provides premium and dependable cab services for corporate employees, supervisors, and guests. With a fleet of sedans, SUVs, and vans, the service ensures comfort, safety, and punctuality. Best Corporate Cabs Ranjangaon is trusted by industries for high-quality travel standards."
  },
  {
    "name": "Affordable Cab Ranjangaon MIDC",
    "description": "Affordable Cab Ranjangaon MIDC offers budget-friendly yet reliable transportation options for employees and suppliers. Despite low pricing, vehicles are clean, well-maintained, and professionally operated. Affordable Cab Ranjangaon MIDC helps companies manage cost-effective travel without compromising safety or comfort."
  },
  {
    "name": "Worker Transport Cabs Ranjangaon",
    "description": "Worker Transport Cabs Ranjangaon provides organized movement for factory workers, technicians, and operators. With shuttle vans, tempo travellers, and shared cab options, the service ensures punctual travel for all shifts. Worker Transport Cabs Ranjangaon supports industries in maintaining workforce efficiency."
  },
  {
    "name": "Monthly Cab Service Ranjangaon",
    "description": "Monthly Cab Service Ranjangaon offers long-term cab rentals with dedicated drivers for companies requiring daily staff commuting. Monthly plans reduce travel costs, ensure vehicle availability, and provide a hassle-free mobility solution. Monthly Cab Service Ranjangaon is ideal for continuous corporate operations."
  },
  {
    "name": "Corporate Fleet Ranjangaon",
    "description": "Corporate Fleet Ranjangaon provides a fully managed fleet of sedans, SUVs, shuttle vans, and staff cabs for corporate travel needs. From daily employee commute to executive travel, the service delivers consistency, safety, and reliability. Corporate Fleet Ranjangaon supports scalable mobility for growing companies."
  },
  {
    "name": "Outstation Corporate Cab Ranjangaon",
    "description": "Outstation Corporate Cab Ranjangaon offers comfortable and punctual long-distance travel for business trips, intercity meetings, and plant visits. With AC sedans and SUVs, professional chauffeurs, and real-time tracking, this service ensures smooth interstate and intercity travel for corporate teams."
  },
  {
    "name": "Sedan Cab Ranjangaon",
    "description": "Sedan Cab Ranjangaon provides clean, comfortable, and well-maintained sedans for executives, managers, and staff requiring corporate travel. Ideal for daily commute, business visits, and intercity travel, Sedan Cab Ranjangaon ensures a premium travel experience with trained drivers and AC comfort."
  },
  {
    "name": "SUV Cab Ranjangaon",
    "description": "SUV Cab Ranjangaon offers spacious and premium SUV vehicles for long-distance travel, executive movement, and industrial visits. With powerful AC, ample legroom, and professional chauffeurs, SUV Cab Ranjangaon provides a comfortable and high-class travel experience for corporate clients."
  },
  {
    "name": "Corporate Shuttle Ranjangaon",
    "description": "Corporate Shuttle Ranjangaon delivers high-capacity shuttle services for employees traveling from nearby towns to Ranjangaon MIDC. Designed for large industrial teams, the service includes fixed routes, multi-shift support, and professional driver management. Corporate Shuttle Ranjangaon ensures efficient mass commuting every day."
  }
],
"tableData": [
  ["Ranjangaon Employee Shuttle", "Industrial Cab Ranjangaon"],
  ["Company Staff Transport Ranjangaon", "Employee Pickup Drop Ranjangaon"],
  ["Business Cab Service Ranjangaon", "Factory Transport Ranjangaon"],
  ["Best Corporate Cabs Ranjangaon", "Affordable Cab Ranjangaon MIDC"],
  ["Worker Transport Cabs Ranjangaon", "Monthly Cab Service Ranjangaon"],
  ["Corporate Fleet Ranjangaon", "Outstation Corporate Cab Ranjangaon"],
  ["Sedan Cab Ranjangaon", "SUV Cab Ranjangaon"],
  ["Corporate Shuttle Ranjangaon", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Ranjangaon MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable and efficient corporate cab services in Ranjangaon MIDC, ideal for industries, plants, and manufacturing units in the area."
  },
  {
    "WhyChooseheading": "Perfect for Industrial & Corporate Travel",
    "WhyChoosedescription": "Our services cater to large-scale companies, factories, and corporate offices operating within Ranjangaon MIDC."
  },
  {
    "WhyChooseheading": "Comfortable & Well-Maintained Fleet",
    "WhyChoosedescription": "All vehicles are regularly serviced, fully sanitized, and equipped to ensure a safe and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Cost-Effective Corporate Packages",
    "WhyChoosedescription": "We offer budget-friendly monthly and daily transportation packages tailored to corporate requirements."
  },
  {
    "WhyChooseheading": "Timely Pickup & Drop for Employees",
    "WhyChoosedescription": "Our team ensures punctual pickup and drop services that align with factory shifts and corporate timing demands."
  },
  {
    "WhyChooseheading": "Professional & Trained Drivers",
    "WhyChoosedescription": "Drivers are experienced, well-trained, and follow all safety protocols for smooth corporate travel."
  },
  {
    "WhyChooseheading": "24/7 Assistance & Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with scheduling, route updates, and urgent requests."
  },
  {
    "WhyChooseheading": "Easy & Fast Booking Process",
    "WhyChoosedescription": "Booking corporate cabs for Ranjangaon MIDC is simple, quick, and hassle-free with Pune Corporate Cars India Private Limited."
  }
]























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Ranjangaon MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and well-managed corporate cab services for companies located in Ranjangaon MIDC.',
  },
  {
    question: 'How can companies in Ranjangaon MIDC book corporate cabs?',
    answer: 'Companies can book easily through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Do you provide employee pickup and drop services in Ranjangaon MIDC?',
    answer: 'Yes, we offer punctual and structured pickup and drop services for employees working in Ranjangaon MIDC.',
  },
  {
    question: 'What types of vehicles are available for corporate transportation in Ranjangaon MIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers suitable for employee commute and business travel needs.',
  },
  {
    question: 'Are monthly and yearly corporate cab contracts available for Ranjangaon MIDC companies?',
    answer: 'Yes, we provide flexible monthly and annual transportation contracts specifically designed for MIDC companies.',
  },
  {
    question: 'Are your drivers experienced with Ranjangaon MIDC routes?',
    answer: 'Absolutely. Our drivers are well-aware of all routes in and around Ranjangaon MIDC, ensuring on-time travel.',
  },
  {
    question: 'Do you support shift-based transportation for industries in Ranjangaon MIDC?',
    answer: 'Yes, we handle all shift timings including night, morning, and rotational shifts.',
  },
  {
    question: 'What safety and hygiene standards do you follow for corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict hygiene, safety, and compliance protocols.',
  },
  {
    question: 'What payment options are available for corporate cab services in Ranjangaon MIDC?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate invoicing methods.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Kadam',
    feedback: 'Pune Corporate Cars India Private Limited has been very reliable for our Ranjangaon MIDC staff transportation. Excellent and timely service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Satpute',
    feedback: 'Their corporate cab services in Ranjangaon MIDC are well-organized and professional. Highly recommended.',
    rating: 5,
  },
];
















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Ranjangaon MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-ranjangaon.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Ranjangaon MIDC, Pune, offering employee shuttles, industrial staff transport, office and factory pickup and drop, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Ranjangaon.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-ranjangaon-midc"
  }
};





  return (
    <div>
      <Helmet>
  <title>Corporate Cab Services in Ranjangaon MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Ranjangaon MIDC, Pune, offering employee shuttles, industrial staff transport, office and factory pickup and drop, and business travel cabs. Chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Ranjangaon."
  />

  <meta
    name="keywords"
    content="Ranjangaon Employee Shuttle, Industrial Cab Ranjangaon, Company Staff Transport Ranjangaon, Employee Pickup Drop Ranjangaon, Business Cab Service Ranjangaon, Factory Transport Ranjangaon, Best Corporate Cabs Ranjangaon, Affordable Cab Ranjangaon MIDC, Worker Transport Cabs Ranjangaon, Monthly Cab Service Ranjangaon, Corporate Fleet Ranjangaon, Outstation Corporate Cab Ranjangaon, Sedan Cab Ranjangaon, SUV Cab Ranjangaon, Corporate Shuttle Ranjangaon"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinranjangaonmidc;